import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LOGO_PATH = `${process.env.PUBLIC_URL || ''}/JK Legacy Logos/JK Legacy Logo.png`;

export default function PageNavigation({ backTo, backLabel = '← Back' }) {
  const navigate = useNavigate();
  const [showLogo, setShowLogo] = useState(false);

  return (
    <>
      {/* Back Button Container - Top Left Corner */}
      {backTo && (
        <div 
          style={{ 
            position: 'fixed', 
            top: 20, 
            left: 20, 
            zIndex: 9998, 
            display: 'flex', 
            alignItems: 'center', 
            gap: 12,
            pointerEvents: 'auto'
          }}
          onMouseEnter={() => setShowLogo(true)}
          onMouseLeave={() => setShowLogo(false)}
        >
          {/* Back Button */}
          <button
            onClick={() => navigate(backTo)}
            style={{
              background: 'rgba(0,0,0,0.8)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(201,166,43,0.3)',
              borderRadius: '9999px',
              padding: '12px 24px',
              color: '#c9a62b',
              fontSize: 14,
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              whiteSpace: 'nowrap'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(201,166,43,0.2)';
              e.currentTarget.style.borderColor = 'rgba(201,166,43,0.5)';
              e.currentTarget.style.transform = 'translateX(-4px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(0,0,0,0.8)';
              e.currentTarget.style.borderColor = 'rgba(201,166,43,0.3)';
              e.currentTarget.style.transform = 'translateX(0)';
            }}
          >
            {backLabel}
          </button>

          {/* JK Legacy Logo - Shows on hover */}
          <div
            onClick={() => navigate('/')}
            style={{
              background: 'rgba(0,0,0,0.8)',
              backdropFilter: 'blur(10px)',
              border: '2px solid rgba(201,166,43,0.3)',
              borderRadius: 12,
              padding: 8,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: showLogo ? 1 : 0,
              transform: showLogo ? 'translateX(0) scale(1)' : 'translateX(-20px) scale(0.9)',
              pointerEvents: showLogo ? 'auto' : 'none'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'rgba(201,166,43,0.6)';
              e.currentTarget.style.transform = 'translateX(0) scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(201,166,43,0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'rgba(201,166,43,0.3)';
              e.currentTarget.style.transform = showLogo ? 'translateX(0) scale(1)' : 'translateX(-20px) scale(0.9)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <img 
              src={LOGO_PATH} 
              alt="JK Legacy - Home" 
              style={{
                width: 80,
                height: 'auto',
                display: 'block'
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}
